const emptyData = {
  BackupDirectory: '',
  TypeOne: false,
  TypeTwo: true,
  Number: null
}

const validationRules = {
  BackupDirectory: [
    {
      required: true,
      message: 'Backup Directory Is Required',
      trigger: 'blur'
    }
  ]
}

export default {
  getEmptyData() {
    return emptyData
  },
  getValidationRule() {
    return validationRules
  }
}
